import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
// import { useDeleteStore, useListStore } from "../stores";
import { toast } from 'react-toastify';
import { useMediaQuery } from 'react-responsive';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
// import { lte } from "lodash";
import { useSelector } from 'react-redux';
import moment from 'moment';
import swal from 'sweetalert';
import { updateRole } from '../actions';
import { getCookie } from '../../auth/actions';

export function CardList({ employees, search, sortData }) {
  console.log('ini search', search);
  console.log('ini sort', sortData);
  parseInt(sortData);
  const [load, setLoad] = useState(false);

  // const [stateDelete, actionsDelete] = useDeleteStore();
  // const [state, actionsList] = useListStore();

  // const employees = useSelector((state) => state.redemploye);

  const handleDelete = async (employe) => {
    confirmAlert({
      title: 'Confirm to delete',
      message: `Are you sure want to delete "${employe.name}"`,
      buttons: [
        {
          label: 'Delete',
          onClick: async () => {
            // actionsDelete.deleteData({ id: employe.id }, () => {
            //   toast.warning(`Delete data "${employe.name}"`);
            //   actionsList.loadData();
            // });
          },
        },
        {
          label: 'Cancel',
          onClick: () => {},
        },
      ],
    });
  };

  useEffect(() => {
    const load = setTimeout(() => {
      setLoad(true);
    }, 3000);
    return () => clearTimeout(load);
  }, []);

  const baseImg =
    'https://cdn.pixabay.com/photo/2017/06/09/07/42/flower-2386049_960_720.jpg';

  const handleImgError = (e) => {
    // e.target.src = baseImg + '/doctor/dr.jpg';
  };

  const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1024 });
    return isDesktop ? children : Default;
  };
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
    return isTablet ? children : null;
  };
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return isMobile ? children : null;
  };
  const Default = ({ children }) => {
    const isNotTabletAndMobile = useMediaQuery({
      minWidth: 768,
      maxWidth: 990,
    });
    return isNotTabletAndMobile ? children : null;
  };

  const getInitials = function (string) {
    if (string) {
      var names = string ? string.split(' ') : '',
        initials = names[0].substring(0, 1).toUpperCase();

      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      return initials;
    }
  };

  const sortIt = (sortData) => (a, b) => {
    if (a[sortData] > b[sortData]) {
      return 1;
    } else if (a[sortData] < b[sortData]) {
      return -1;
    }
    return 0;
  };

  // const role = '1';

  const handleToggle = async (e, employee) => {
    const token = getCookie('token');

    if (e.target.checked === true) {
      console.log('checked');
      const user = { role: '1' };
      await swal({
        title: `Are you sure to publish "${employee.name}"?`,
        icon: 'info',
        buttons: true,
      }).then((success) => {
        // const { role } = 0;
        if (success)
          updateRole(user, employee._id).then((data) => {
            if (data.error) {
              toast.warning(`Error Unpublishing Data "${employee.name}"`);
            } else {
              toast.success(`Publishing "${employee.name}"`);
            }
          });
        // actionEdit.updatePublish(
        //   {
        //     _id: employee._id,
        //     publish: e.target.checked,
        //   },
        //   () => {
        //     toast.info(`Success Publish "${employee.name}"`);
        //     actionsList.loadData();
        //   }
        // );
        console.log('1');
      });
    } else {
      console.log('NOT checked');
      const user = { role: '0' };
      await swal({
        title: `Are you sure not to publish "${employee.name}"?`,
        icon: 'warning',
        buttons: true,
      }).then((success) => {
        if (success)
          updateRole(user, employee._id).then((data) => {
            if (data.error) {
              toast.warning(`Error Unpublishing Data "${employee.name}"`);
            } else {
              toast.success(`Unpublishing "${employee.name}"`);
            }
          });
        // actionEdit.updatePublish(
        //   {
        //     _id: employee._id,
        //     publish: e.target.checked,
        //   },
        //   () => {
        //     toast.warning(`Unpublishing "${employee.name}"`);
        //     actionsList.loadData();
        //   }
        // );
        console.log('1');
      });
    }
  };

  let contentUi = <div className='loader-block' />;
  if (load) {
    contentUi = (
      <>
        <section>
          <div className='ml-auto'>
            <div className='w-full mb-4'>
              <Desktop>
                <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg '>
                  <div className='px-6 py-4'>
                    <div className='grid lg:grid-cols-6'>
                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Photo</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'> Name</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Email </p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Join At</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Action</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Access</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Desktop>
            </div>

            {load
              ? employees
                  .filter((employe) => {
                    if (!search) return true;
                    if (
                      employe.name.toLowerCase().includes(search) ||
                      employe.name.toLowerCase().includes(search) ||
                      employe.name.toUpperCase().includes(search) ||
                      employe.name.toUpperCase().includes(search)
                    ) {
                      return true;
                    }
                  })
                  .filter((employe) => {
                    if (!sortData) return true;
                    if (
                      employe.role.toString().includes(sortData) ||
                      employe.role.toString().includes(sortData)
                    ) {
                      return true;
                    }
                  })
                  .map((employe, i) => (
                    <>
                      <Desktop>
                        <div className='bg-white rounded overflow-hidden shadow-md rounded-lg mb-4 px-4 py-4'>
                          <div className='grid  lg:grid-cols-6'>
                            <div className='px-4  bg-white flex items-center rounded'>
                              <div className='avatar sm:w-28 sm:h-28 md:w-28 md:h-28 xl:w-28 xl:h-28 2xl:w-28 2xl:h-28'>
                                {employe.name
                                  ? getInitials(employe.name)
                                  : null}
                              </div>
                            </div>
                            <div className='px-4  bg-white flex items-center rounded'>
                              <Link
                                to={`/employe-management/detail/${employe._id}`}
                              >
                                <p className='font-bold text-left '>
                                  {employe.name}
                                </p>
                              </Link>
                            </div>
                            <div className='px-4  bg-white flex items-center rounded'>
                              <p className='font-bold'>{employe.email}</p>
                            </div>

                            <div className='px-4  bg-white flex items-center rounded'>
                              {/* <p className='font-bold'>{employe.createdAt}</p> */}
                              <div>
                                <p className='font-bold'>
                                  {moment(
                                    `${employe.createdAt}`,
                                    'YYYYMMDDHHmm'
                                  ).format('HH:mm A')}
                                </p>
                                {/* <br /> */}
                                <p className='text-xs'>
                                  {moment(
                                    `${employe.createdAt}`,
                                    'YYYYMMDDHHmm'
                                  ).format('DD/MM/YYYY')}
                                </p>
                              </div>
                            </div>
                            <div className='px-4 items-center rounded my-auto'>
                              <div className='flex items-center my-auto'>
                                <div className='flex items-center my-auto'>
                                  {/* <Link
                                    to={`/employe-management/edit/${employe.id}`}
                                    className='btn btn-icon btn_outlined btn_secondary'
                                  >
                                    <span className='la la-pen-fancy'></span>
                                  </Link> */}
                                  <button
                                    type='button'
                                    className='btn btn-icon btn_outlined btn_danger ml-2'
                                    onClick={(e) => handleDelete(employe)}
                                  >
                                    <span className='la la-trash-alt'></span>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className='px-4 items-center rounded my-auto'>
                              <div className='flex items-center'>
                                <div className='items-center justify-items-center'>
                                  <label className='switch inline-block h-10'>
                                    {' '}
                                    <input
                                      type='checkbox'
                                      name='toggle'
                                      id={'toggle1'}
                                      className='toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer'
                                      value={employe.role}
                                      defaultChecked={employe.role === 1}
                                      onChange={(e) => {
                                        handleToggle(e, employe);
                                      }}
                                    />
                                    <span className='slider cursor-pointer inset-0 absolute round rounded-full'></span>
                                  </label>
                                  <div className='text-right'>
                                    <label
                                      htmlFor='toggle'
                                      className=' text-gray-700'
                                    >
                                      {employe.role === 0
                                        ? 'Unpublish'
                                        : 'Publish'}
                                      {/* Publish */}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Desktop>

                      <Tablet>
                        <div className='bg-white rounded overflow-hidden shadow-md rounded-lg mb-4 px-4 py-4'>
                          <div className='px-2 py-2 border-b'>{/*  */}</div>
                          <div className='grid py-6 lg:grid-cols-5'>
                            <div className='px-4 bg-white flex items-center justify-center rounded '>
                              <Link
                                to={`/employe-management/detail/${employe._id}`}
                              >
                                <div className='items-center gap-3 max-w-xs'>
                                  <div>
                                    <span className='rounded-lg w-19 h-19 text-xs'>
                                      <img
                                        src={employe.pictureURL}
                                        onError={handleImgError}
                                        alt='employe-avatar'
                                        className='rounded-lg mb-3'
                                      />
                                    </span>
                                  </div>
                                </div>
                              </Link>
                            </div>
                            <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                              <Link
                                to={`/employe-management/detail/${employe._id}`}
                              >
                                <div className='items-center gap-3 max-w-xs'>
                                  <div>
                                    <div>
                                      <p className='font-bold text-md'>
                                        {employe.name}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                            <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                              <div className='items-center gap-3 max-w-xs'>
                                <div>
                                  <div>
                                    <p className='font-bold text-xs'>
                                      {employe.type}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <Table
                            className='table border-none'
                            style={{ border: 'none !important' }}
                          >
                            {/* .responsiveTable tbody tr */}
                            <Thead style={{ border: 'none !important' }}>
                              <Tr style={{ border: 'none !important' }}>
                                <Th className='text-left text-xs'>
                                  Description
                                </Th>
                              </Tr>
                            </Thead>
                            <Tbody style={{ border: 'none !important' }}>
                              <Tr key={i} style={{ border: 'none !important' }}>
                                <Td>{employe.description}</Td>
                              </Tr>
                            </Tbody>
                          </Table>
                          <hr />
                          <Table
                            className='table border-none justify-center align-center'
                            style={{ border: 'none !important' }}
                          >
                            <Tbody style={{ border: 'none !important' }}>
                              <Tr key={i} style={{ border: 'none !important' }}>
                                <Td className='items-center flex justify-center w-full'>
                                  <div>
                                    {/* <Link
                                      to={`/employe-management/edit/${employe.id}`}
                                      className='btn btn-icon btn_outlined btn_secondary'
                                    >
                                      <span className='la la-pen-fancy'></span>
                                    </Link> */}
                                  </div>
                                  <div>
                                    <button
                                      type='button'
                                      className='btn btn-icon btn_outlined btn_danger ml-2'
                                      onClick={(e) => handleDelete(employe)}
                                    >
                                      <span className='la la-trash-alt'></span>
                                    </button>
                                  </div>
                                </Td>
                              </Tr>
                            </Tbody>
                          </Table>
                          <hr />
                          <p className='text-xs text-right text-gray-300'>
                            {moment(
                              `${employe.createdAt}`,
                              'YYYYMMDDHHmm'
                            ).format('DD/MM/YYYY')}
                          </p>
                        </div>
                      </Tablet>

                      <Mobile>
                        <div className='bg-white rounded overflow-hidden shadow-md rounded-lg mb-4 px-4 py-4'>
                          <div className='px-2 py-2 border-b'>{/*  */}</div>
                          <div className='grid py-6 lg:grid-cols-5'>
                            <div className='px-4 bg-white flex items-center justify-center rounded '>
                              <div className='px-4  bg-white flex items-center rounded'>
                                <div className='avatar sm:w-28 sm:h-28 md:w-28 md:h-28 xl:w-28 xl:h-28 2xl:w-28 2xl:h-28'>
                                  {employe.name
                                    ? getInitials(employe.name)
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className='px-4 bg-white flex items-center justify-center rounded mt-3'>
                              <Link
                                to={`/employe-management/detail/${employe._id}`}
                              >
                                <div className='items-center gap-3 max-w-xs'>
                                  <div>
                                    <div>
                                      <p className='font-bold text-md'>
                                        {employe.name}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                            <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                              <div className='items-center gap-3 max-w-xs'>
                                <div>
                                  <div>
                                    <p className='font-bold text-md'>
                                      {employe.email}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                              <div className='items-center gap-3 max-w-xs'>
                                <div>
                                  <div>
                                    <p className='font-bold text-xs'>
                                      Joined At{' '}
                                      {moment(
                                        `${employe.createdAt}`,
                                        'YYYYMMDDHHmm'
                                      ).format('DD/MM/YYYY')}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <div className='flex justify-center space-x-7 mt-3'>
                            <button
                              type='button'
                              className='btn btn-icon btn_outlined btn_danger ml-2'
                              onClick={(e) => handleDelete(employe)}
                            >
                              <span className='la la-trash-alt'></span>
                            </button>
                            <div className='items-center justify-items-center'>
                              <label className='switch inline-block h-10'>
                                {' '}
                                <input
                                  type='checkbox'
                                  name='toggle'
                                  id={'toggle1'}
                                  className='toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer'
                                  // value={row.publish}
                                  // defaultChecked={row.publish}
                                  onChange={(e) => {
                                    // handleToggle(e, row);
                                  }}
                                />
                                <span className='slider cursor-pointer inset-0 absolute round rounded-full'></span>
                              </label>
                              <div className='text-right'>
                                <label
                                  htmlFor='toggle'
                                  className=' text-gray-700'
                                >
                                  {/* {row.publish === false
                                    ? 'Unpublish'
                                    : 'Publish'} */}{' '}
                                  Publish
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Mobile>
                    </>
                  ))
              : null}
          </div>
        </section>
      </>
    );
  }

  return contentUi;
}
